/* Autogenerated file. Do not modify */
define([], function() {
    'use strict';
    var skins = {};
     skins['wysiwyg.viewer.skins.mediaPlayerSkin'] = {
  "react": [
    [
      "div",
      "container",
      [],
      {},
      [
        "div",
        "background",
        [],
        {}
      ],
      [
        "div",
        "inlineContentParent",
        [],
        {},
        [
          "div",
          "inlineContent",
          [],
          {}
        ]
      ]
    ]
  ],
  "css": {
    "% *": "-webkit-tap-highlight-color:rgba(0, 0, 0, 0);",
    "%inlineContentParent": "position:absolute;top:0;right:0;bottom:0;left:0;",
    "%container": "position:absolute;top:0;left:0;width:100%;height:100%;"
  }
}

    return skins;
});
